import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { PopupType } from '../models/property-popup-type.enum';
import { VendorSearchComponent } from '../vendor-search/vendor-search.component';
import { VendorAddComponent } from '../vendor-add/vendor-add.component';
import { Vendor } from '../models/vendor';
import { Party } from '../models/party';

@Component({
  selector: 'pioneer-vendor-popup',
  templateUrl: './vendor-popup.component.html'
})
export class VendorPopupComponent implements OnInit {

  @Input()
  currentEventVendors: Party[];

  propertyPopupType = PopupType.SEARCH;

  PopupType = PopupType;

  selectedProperty: Vendor;

  @ViewChild(ModalDirective)
  propertyModal: ModalDirective;

  @ViewChild(VendorSearchComponent)
  propertySearch: VendorSearchComponent;

  @ViewChild(VendorAddComponent)
  propertyAdd: VendorAddComponent;

  vendorSelected: string;

  config = {
    backdrop: 'static',
    keyboard: false
  };

  @Output()
  closed = new EventEmitter<Vendor>();

  constructor() { }

  ngOnInit() {
  }

  open(): void {
    this.propertyPopupType = PopupType.SEARCH;
    this.propertyModal.show();
  }

  goToAdd(vendorType: string): void {
    this.vendorSelected = vendorType;
    this.propertyPopupType = PopupType.ADD;
  }

  cancelSearch(): void {
    this.close(null);
  }

  selectProperty(propertySelected: Vendor) {
    if (this.propertyAdd) {
      this.propertyAdd.reset();
    }
    this.propertySearch.reset();
    this.selectedProperty = propertySelected;
    this.propertyPopupType = PopupType.RATE;
  }

  selectVendorRate(propertySelected: Vendor) {
    this.close(propertySelected);
  }

  acceptAdd(savedProperty: Vendor): void {
    if (this.propertyAdd) {
      this.propertyAdd.reset();
      savedProperty.manuallyAdded = true;
    }
    this.propertySearch.reset();
    this.selectedProperty = savedProperty;
    this.propertyPopupType = PopupType.RATE;
  }

  cancelAdd(): void {
    this.propertyPopupType = PopupType.SEARCH;
  }

  private close(value: Vendor): void {
    this.closed.emit(value);
    this.propertyModal.hide();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-popup/vendor-popup.component.ts